export const handleAddPenalty = (
    removeTime: (seconds: number) => void,
    setIsPenaltyAdded: (value: boolean) => void,
) => {
    removeTime(5);
    setIsPenaltyAdded(true);
    setTimeout(() => {
        setIsPenaltyAdded(false);
    }, 1000);
};
